import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getAntalBokmoteByAfidUserid,setofUpdatedashboardBokaTV} from 'actions'
import {isEmpty, isNull,isUndefined} from 'lodash'
import BackGroupChart from '../Charts/BackGroupChart'
import {Grid} from '@material-ui/core'
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY } = accountsData 
    const { BokmoteAntalSal,SenasteBokmote,DashboardAnpassadFilterOption,BokmoteAntalSalBack,BokmoteAntalSalFram} = DashBoard;
    return {
        authUser,BokmoteAntalSal,DashboardAnpassadFilterOption,SenasteBokmote,BokmoteAntalSalBack,BokmoteAntalSalFram,
        updatedashboardBokaTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAntalBokmoteByAfidUserid: (Afid,userid,DashboardAnpassadFilterOption) => dispatch(getAntalBokmoteByAfidUserid(Afid,userid,DashboardAnpassadFilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    };
}
class TopList extends Component {
    state={
        cardHeight: 0,
        BokmoteAntalSal:0,
        done: true,
        DashboardAnpassadFilterOption:isEmpty(this.props.DashboardAnpassadFilterOption)?[]:this.props.DashboardAnpassadFilterOption
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
        this.props.getAntalBokmoteByAfidUserid(Afid,userid,this.props.DashboardAnpassadFilterOption)
        .then(() => {
          this.initiateInterval() 
        //  this.setState({done: true})   
      })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
              if(this.state.done === true){            
              //  this.setState({done: false}) 
                const Afid = this.props.authUser.user_Afid;
                const userid = this.props.authUser.user_id;
                this.props.getAntalBokmoteByAfidUserid(Afid,userid,this.props.DashboardAnpassadFilterOption)
                .then(() => {
                  this.initiateInterval() 
                //  this.setState({done: true})   
              })
            }
            },
            180000
        );           
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      if(parseInt(this.props.updatedashboardBokaTY) === 1){
        this.props.getAntalBokmoteByAfidUserid(Afid,userid,this.props.DashboardAnpassadFilterOption) /**/
        .then(() => {
         this.initiateInterval() 
       //  this.setState({done: true})   
     })
        this.props.setofUpdatedashboardBokaTV()
    }
        if(this.props.DashboardAnpassadFilterOption !== this.state.DashboardAnpassadFilterOption && !isEmpty(this.props.DashboardAnpassadFilterOption))
           {
          //  this.setState({done: false})                
               this.props.getAntalBokmoteByAfidUserid(Afid,userid,this.props.DashboardAnpassadFilterOption) /**/
               .then(() => {
                this.initiateInterval() 
             //   this.setState({done: true})   
            })
               this.setState({
                DashboardAnpassadFilterOption:this.props.DashboardAnpassadFilterOption 
               }) 
           }
        }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
  setHeight=(node)=> {
    if(!isNull(node)) {
      this.setState({
        cardHeight: node.getBoundingClientRect().height
      })
    }
  }

  render() {
    return (
      <>
          <div
            style={{ backgroundColor: 'transparent', position: 'relative', paddingTop: this.state.cardHeight-(this.state.cardHeight / 1.3),
            height:isUndefined(this.props.FontColor)?100:"100%" }}>  
            <BackGroupChart height={this.state.cardHeight / 1.3}/>
          </div>
            
          <div className="jr-fillchart-content  h-100" style={{zIndex:0,
          height:isUndefined(this.props.FontColor)?100:"100%"
          }} ref={this.setHeight}>
            <div className="text-center text-white">
              <h2 style={{  
                paddingTop: this.props.isFrom === 1 ? '0px' : '12px',
                margin: '0', 
                fontSize: this.props.isFrom === 1 ? '20px' : '24px',color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor }}>
                <b><IntlMessages id="Event.Booked"/></b>
              </h2>
              <p style={{ fontSize: this.props.isFrom === 1 ? 14 : '18px', textTransform: "capitalize",color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor }}>
                {format(new Date(), 'MMMM', { locale: sv })}
              </p>
            </div>
            <div>
              {
                this.state.done === false?  
                <Skeleton variant="rectangular" height={120} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                :
                this.props.isFrom === 1 ?
                <Grid
                  container
                  direction="row"
                >
                  <Grid item xs={3} style={{ marginTop: '-0.5rem', textAlign: 'center',alignSelf:'center' }}>
                    <h4 style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><IntlMessages id="DashBoard.Last30.days"/></h4>
                    <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSalBack)}</span>
                    <span style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>

                  <Grid item xs={6} style={{ marginTop: '-0.5rem', textAlign: 'center' }}>
                    <span style={{ fontSize: 55,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSal)}</span>
                    <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>

                  <Grid item xs={3} style={{ marginTop: '-0.5rem', textAlign: 'center',alignSelf:'center' }}>
                    <h4 style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><IntlMessages id="DashBoard.Ahead30.days"/></h4>
                    <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSalFram)}</span>
                    <span style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>
                </Grid>
                : 
                <Grid
                  container
                  direction="row"
                >
                  <Grid item xs={3} style={{ marginTop: '-0.5rem', textAlign: 'center',alignSelf:'center' }}>
                    <h4 style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><IntlMessages id="DashBoard.Last30.days"/></h4>
                    <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSalBack)}</span>
                    <span style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: '0rem', textAlign: 'center' }}>
                    <span style={{ fontSize: 100,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSal)}</span>
                    <span style={{ fontSize: 35,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>
                  <Grid item xs={3} style={{ marginTop: '-0.5rem', textAlign: 'center' ,alignSelf:'center'}}>
                    <h4 style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><IntlMessages id="DashBoard.Ahead30.days"/></h4>
                    <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>{this.formatNumber(this.props.BokmoteAntalSalFram)}</span>
                    <span style={{ fontSize: 10,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>St</span>
                  </Grid>
                </Grid>
              }
              <Grid
                container
                direction="row"
              >
                 {
                      this.state.done === false?  
                      <Skeleton variant="rectangular" height={40} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                      : 
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                  >
                  <span style={{ fontSize: 25,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>
                    {
                      isEmpty(this.props.SenasteBokmote)?""
                      :
                      <>
                        <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="DashBoard.Latest"/></p>
                        <p className="m-0 p-0" style={{
                          fontSize: this.props.isFrom === 1 ? 18 : 25,
                          whiteSpace: "nowrap",
                          width: "300px", 
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}>
                          {this.props.SenasteBokmote.KundNamn}
                        </p>
                      </>
                    }
                  </span>
                  <span style={{ fontSize: 20,color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>
                    {
                      isEmpty(this.props.SenasteBokmote)?""
                      :
                      <>
                        <p className="m-0 p-0" style={{fontSize:14}}><IntlMessages id="Booked"/></p>
                        <p className="m-0 p-0" style={{fontSize: this.props.isFrom === 1 ? 16 : 20}}>
                         {this.formatNumber(this.props.SenasteBokmote.RegDatum)}
                        </p>
                      </>
                    }
                  </span>
                </Grid>
              </Grid>
  }
            </Grid>
          </div>
        </div>
    </>
    );
  }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(TopList);

